import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, ZapIcon, FlameIcon, DropletIcon, WifiIcon, SmartphoneIcon, LandmarkIcon, ChevronRightIcon } from 'lucide-react';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 12
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.35,
      ease: 'easeOut'
    }
  }
};
const stagger = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08
    }
  }
};
export function PaymentsScreen() {
  const categories = [{
    icon: ZapIcon,
    label: 'Electricity'
  }, {
    icon: FlameIcon,
    label: 'Gas'
  }, {
    icon: DropletIcon,
    label: 'Water'
  }, {
    icon: WifiIcon,
    label: 'Internet'
  }, {
    icon: SmartphoneIcon,
    label: 'Mobile'
  }, {
    icon: LandmarkIcon,
    label: 'Government'
  }];
  const recentBillers = [{
    company: 'LESCO',
    account: '034982349823',
    amount: 'Rs 12,450',
    date: '12 Oct 2023'
  }, {
    company: 'SNGPL',
    account: '9823498234',
    amount: 'Rs 3,200',
    date: '05 Oct 2023'
  }, {
    company: 'PTCL',
    account: '0423589234',
    amount: 'Rs 2,890',
    date: '01 Oct 2023'
  }];
  return <motion.div initial="hidden" animate="show" variants={stagger} className="w-full min-h-screen pb-24" style={{
    backgroundColor: '#FFF7F3'
  }} data-id="element-495">
      {/* Header */}
      <motion.div variants={fadeUp} className="px-6 pt-8 pb-4" data-id="element-496">
        <h1 className="text-2xl font-bold text-[#303030]" data-id="element-497">Bill Payments</h1>
      </motion.div>

      <div className="px-6 space-y-8" data-id="element-498">
        {/* Search Bar */}
        <motion.div variants={fadeUp} data-id="element-499">
          <div className="relative" data-id="element-500">
            <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#818285]" data-id="element-501" />
            <input type="text" placeholder="Search billers" className="w-full pl-12 pr-4 py-3.5 bg-white border border-[#F0E8E3] rounded-2xl outline-none text-[15px] text-[#303030] placeholder:text-[#818285] shadow-sm focus:border-[#F37024] transition-colors" data-id="element-502" />
          </div>
        </motion.div>

        {/* Categories */}
        <motion.div variants={fadeUp} data-id="element-503">
          <h3 className="text-lg font-bold text-[#303030] mb-4" data-id="element-504">Categories</h3>
          <div className="grid grid-cols-3 gap-3" data-id="element-505">
            {categories.map((category, index) => {
            const Icon = category.icon;
            return <button key={index} className="bg-white rounded-[20px] p-4 flex flex-col items-center gap-3 shadow-sm hover:shadow-md transition-shadow border border-[#F0E8E3]" data-id="element-506">
                  <div className="w-12 h-12 rounded-2xl bg-[#FFF7F3] flex items-center justify-center" data-id="element-507">
                    <Icon className="w-6 h-6 text-[#F37024]" strokeWidth={2} data-id="element-508" />
                  </div>
                  <span className="text-[11px] font-semibold text-[#303030] text-center leading-tight" data-id="element-509">
                    {category.label}
                  </span>
                </button>;
          })}
          </div>
        </motion.div>

        {/* Recent Billers */}
        <motion.div variants={fadeUp} data-id="element-510">
          <div className="flex items-center justify-between mb-4" data-id="element-511">
            <h3 className="text-lg font-bold text-[#303030]" data-id="element-512">Recent Billers</h3>
            <button className="text-[13px] font-semibold text-[#F37024]" data-id="element-513">
              View All
            </button>
          </div>
          <div className="space-y-3" data-id="element-514">
            {recentBillers.map((biller, index) => <button key={index} className="w-full bg-white rounded-[20px] p-4 flex items-center justify-between shadow-sm hover:shadow-md transition-shadow border border-[#F0E8E3]" data-id="element-515">
                <div className="flex items-center gap-4" data-id="element-516">
                  <div className="w-12 h-12 rounded-full bg-[#FFF7F3] flex items-center justify-center text-[#F37024] font-bold text-lg" data-id="element-517">
                    {biller.company.charAt(0)}
                  </div>
                  <div className="text-left" data-id="element-518">
                    <p className="text-[15px] font-bold text-[#303030]" data-id="element-519">
                      {biller.company}
                    </p>
                    <p className="text-[12px] font-medium text-[#818285]" data-id="element-520">
                      {biller.account}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-521">
                  <div className="text-right" data-id="element-522">
                    <p className="text-[15px] font-bold text-[#303030]" data-id="element-523">
                      {biller.amount}
                    </p>
                    <p className="text-[11px] font-medium text-[#818285]" data-id="element-524">
                      {biller.date}
                    </p>
                  </div>
                  <ChevronRightIcon className="w-5 h-5 text-[#818285]" data-id="element-525" />
                </div>
              </button>)}
          </div>
        </motion.div>
      </div>
    </motion.div>;
}